import FormView from '../../../../components/views/formView';
import { Status } from './status';
import { useAlertsForm } from './hook';
import { Process } from './process';
import { AlertStatus } from './alertStatus';
import { Alert } from './alert';
import { Grid } from '@mui/material';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { AlertsFormProps } from './props';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    ALERTS,
    ALERTS_DETAIL,
    ALERTS_EDIT,
} from '../../../../../routes/paths';

export const AlertsForm = ({ showFormView }: AlertsFormProps) => {
    const {
        alert,
        setFormikStatus,
        setFormikProcess,
        setFormikAlertStatus,
        setFormikAlert,
        handleSubmit,
        handleClean,
        loading,
        formikStatus,
        formikProcess,
        formikAlertStatus,
        formikAlert,
    } = useAlertsForm();

    return (
        <>
            {showFormView && (
                <FormView
                    title={
                        alert && alert.id
                            ? 'Editar alerta'
                            : 'Crear reglas alertas'
                    }
                    additionalButtons={
                        <ActionButtonGroup
                            id={alert?.id || ''}
                            buttonSearch={{
                                show: true,
                                route: ALERTS,
                            }}
                            buttonUpdate={{
                                show: true,
                                route: ALERTS_EDIT,
                            }}
                            buttonView={{
                                show: true,
                                route: ALERTS_DETAIL,
                            }}
                        />
                    }
                />
            )}
            <Status
                data={alert?.status}
                onChangeFormik={(formik) => setFormikStatus(formik)}
                isEdit={Boolean(alert && alert.id)}
            />
            <Process
                data={alert?.process}
                onChangeFormik={(formik) => setFormikProcess(formik)}
            />
            <AlertStatus
                data={alert?.alertStatus}
                onChangeFormik={(formik) => setFormikAlertStatus(formik)}
                isEdit={Boolean(alert && alert.id)}
            />
            <Alert
                data={alert?.alertSection}
                onChangeFormik={(formik) => setFormikAlert(formik)}
                formikStatus={formikStatus}
                formikProcess={formikProcess}
                formikAlertStatus={formikAlertStatus}
                formikAlert={formikAlert}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                {(!alert || !alert.id) && (
                    <LoadingButtonGeneral
                        disabled={loading}
                        title="Limpiar"
                        variant="outlined"
                        onClick={handleClean}
                    />
                )}
            </Grid>
        </>
    );
};
